import { render, staticRenderFns } from "./dynamicBoard.vue?vue&type=template&id=4a050af6"
import script from "./dynamicBoard.vue?vue&type=script&lang=js"
export * from "./dynamicBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports